var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__back-button"},[_c('el-button',{attrs:{"name":"back-btn","type":"info","plain":true},on:{"click":_vm.backHandler}},[_vm._v(_vm._s(_vm.$tf('back')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }